module.exports = __webpack_public_path__ + "2acb60f2/img/scraper-icon.df6ccde5.svg";